document.addEventListener('click', function (event) {

	// If the clicked element doesn't have the right selector, bail
	if (!event.target.matches('#menu')) return;

	let links = document.getElementById('links');

	if(links) {
		event.target.classList.toggle('open');
		links.classList.toggle('open');
	}

}, false);